<template>
  <div class="sidebar-wrapper">
    <!-- Logo区域 - 点击折叠/展开 -->
    <div class="logo-container" @click="handleToggle">
      <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
      <span v-show="!isCollapse" class="logo-text">快影兔</span>
      <el-icon v-show="!isCollapse" class="collapse-icon"
        ><ArrowLeft
      /></el-icon>
    </div>

    <!-- 导航菜单 -->
    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      :collapse="isCollapse"
      :collapse-transition="false"
      background-color="#1e1e1e"
      text-color="#b3b3b3"
      active-text-color="#8bff8b"
      router
    >
      <el-menu-item index="/home">
        <el-icon><House /></el-icon>
        <template #title>首页</template>
      </el-menu-item>

      <!-- 开始创作 - 弹窗，不选中（主账号） -->
      <!-- <div
        v-if="!isSubAccount"
        class="menu-item-wrapper"
        @click="handleCreateProject"
      >
        <el-menu-item index="" :style="{ pointerEvents: 'none' }">
          <el-icon><MagicStick /></el-icon>
          <template #title>开始创作</template>
        </el-menu-item>
      </div> -->

      <!-- 我的项目：由外层点击处理跳转，避免未登录时 el-menu 先 push /projects 再被守卫重定向报错 -->
      <div
        class="menu-item-wrapper"
        :class="{ 'is-route-active': route.path === '/projects' }"
        @click="handleProjectsClick"
      >
        <el-menu-item index="" :style="{ pointerEvents: 'none' }">
          <el-icon><FolderOpened /></el-icon>
          <template #title>我的项目</template>
        </el-menu-item>
      </div>

      <el-menu-item v-if="!isSubAccount" index="/team">
        <el-icon><Connection /></el-icon>
        <template #title>我的团队</template>
      </el-menu-item>

      <el-menu-item v-if="!isSubAccount" index="/myAssets">
        <el-icon><Wallet /></el-icon>
        <template #title>我的资产</template>
      </el-menu-item>

      <!-- <el-menu-item v-if="!isSubAccount" index="/freeCreate">
        <el-icon><EditPen /></el-icon>
        <template #title>自由创作</template>
      </el-menu-item> -->

      <!-- <el-menu-item v-if="!isSubAccount" index="/classicMode">
        <el-icon><Film /></el-icon>
        <template #title>经典模式</template>
      </el-menu-item> -->

      <el-menu-item v-if="!isSubAccount" index="/orderSquare">
        <el-icon><Briefcase /></el-icon>
        <template #title>接单广场</template>
      </el-menu-item>

      <el-menu-item v-if="!isSubAccount" index="/community">
        <el-icon><ChatLineRound /></el-icon>
        <template #title>社区&活动</template>
      </el-menu-item>


      <!-- <el-menu-item v-if="!isSubAccount" index="/test3d">
        <el-icon><Monitor /></el-icon>
        <template #title>3D测试</template>
      </el-menu-item> -->
    </el-menu>

    <!-- 底部菜单 -->
    <div class="bottom-menu">
      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        :collapse="isCollapse"
        :collapse-transition="false"
        background-color="#1e1e1e"
        text-color="#b3b3b3"
        active-text-color="#8bff8b"
      >
        <!-- 算力 - 页面跳转（主账号） -->
        <el-menu-item
          v-if="!isSubAccount"
          index="/credits"
          @click="handleCreditsClick"
        >
          <el-icon><Lightning /></el-icon>
          <template #title>
            算力
            <el-tag size="small" type="success" class="power-tag">{{
              userInfoData.points || 0
            }}</el-tag>
          </template>
        </el-menu-item>
        <!-- <div class="menu-item-wrapper" @click="handleMessageClick">
          <el-menu-item index="" :style="{ pointerEvents: 'none' }">
            <el-icon><Bell /></el-icon>
            <template #title>消息</template>
          </el-menu-item>
        </div> -->

        <!-- 教程 - 弹窗，不选中 -->
        <div class="menu-item-wrapper" @click="handleTutorialClick">
          <el-menu-item index="" :style="{ pointerEvents: 'none' }">
            <el-icon><VideoCamera /></el-icon>
            <template #title>教程</template>
          </el-menu-item>
        </div>

        <!-- AI短剧交流群 - 弹窗，不选中 -->
        <div class="menu-item-wrapper" @click="handleCommunityClick">
          <el-menu-item index="" :style="{ pointerEvents: 'none' }">
            <el-icon><ChatDotRound /></el-icon>
            <template #title>AI短剧交流群</template>
          </el-menu-item>
        </div>

        <!-- 邀请有礼 - 路由跳转，可以有选中状态（主账号） -->
        <el-menu-item
          v-if="!isSubAccount"
          index="/invitation"
          @click="handleInvitationClick"
        >
          <el-icon><Present /></el-icon>
          <template #title>邀请有礼</template>
        </el-menu-item>

        <!-- 个人信息 - 路由跳转 -->
        <el-menu-item index="/profile" @click="handleProfileClick">
          <el-icon><UserFilled /></el-icon>
          <template #title>个人信息</template>
        </el-menu-item>
      </el-menu>

      <div v-if="islogin && !isCollapse && !isSubAccount" class="storage-section">
        <div class="storage-title">存储空间</div>
        <div class="storage-progress">
          <div
            class="storage-progress-inner"
            :class="isStorageHighUsage ? 'is-danger' : 'is-safe'"
            :style="{ width: `${storagePercent}%` }"
          ></div>
        </div>
        <div class="storage-meta">
          <span class="storage-used">已用 {{ formatStorageSize(storageUsed) }}</span>
          <span
            class="storage-status"
            :class="{ 'is-inactive': !storageTotal }"
          >
            {{ storageRemainingText }}
          </span>
        </div>
      </div>

      <!-- 登录按钮 -->
      <div
        class="login-btn"
        :class="{ 'is-collapse': isCollapse }"
        @click="handleLogin"
      >
        <el-icon><SwitchButton /></el-icon>
        <span v-show="!isCollapse">{{ islogin ? "退出登录" : "登录" }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onActivated, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import {
  ArrowLeft,
  House,
  MagicStick,
  FolderOpened,
  Wallet,
  Bell,
  Lightning,
  VideoCamera,
  ChatDotRound,
  Present,
  UserFilled,
  SwitchButton,
  Connection,
  EditPen,
  Film,
  Monitor,
  Briefcase,
  ChatLineRound,
} from "@element-plus/icons-vue";
import { EventBus, EVENTS } from "@/utils/eventBus";
import { userInfo, ainewAiSettinginfo, teamMyStorage } from "@/api";
import { isSubAccount as checkIsSubAccount } from "@/utils/accountPermission";
import { formatStorageSize } from "@/utils/formatStorageSize";

defineOptions({
  name: "Sidebar",
});

const props = defineProps({
  isCollapse: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["toggle", "login"]);

const route = useRoute();
const router = useRouter();

const islogin = ref(false);
const userInfoData = ref({});
const AiSettinginfo = ref({});
const storageInfo = ref({});

const activeMenu = computed(() => {
  if (route.path.startsWith("/freeCreate")) {
    return "/freeCreate";
  }
  if (route.path.startsWith("/orderSquare")) {
    return "/orderSquare";
  }
  if (route.path.startsWith("/community")) {
    return "/community";
  }
  return route.path;
});

const isSubAccount = computed(() => {
  if (userInfoData.value.accountType != null) {
    return Number(userInfoData.value.accountType) === 1;
  }
  return checkIsSubAccount();
});

const storageUsed = computed(() => {
  const info = storageInfo.value || {};
  return Number(info.usedSpace ?? info.spaceUsed ?? info.useSpace ?? 0) || 0;
});

const storageTotal = computed(() => {
  const info = storageInfo.value || {};
  return Number(info.totalSpace ?? info.spaceTotal ?? info.maxSpace ?? 0) || 0;
});

const storageRemaining = computed(() => {
  const info = storageInfo.value || {};
  if (info.availableSpace != null && info.availableSpace !== "") {
    return Number(info.availableSpace) || 0;
  }
  return Math.max(storageTotal.value - storageUsed.value, 0);
});

const storagePercent = computed(() => {
  if (!storageTotal.value) {
    return storageUsed.value > 0 ? 100 : 0;
  }
  return Math.min((storageUsed.value / storageTotal.value) * 100, 100);
});

const isStorageHighUsage = computed(() => storagePercent.value > 80);

const storageRemainingText = computed(() => {
  if (!storageTotal.value) return "未开通";
  return `剩余 ${formatStorageSize(storageRemaining.value)}`;
});

function getainewAiSettinginfo() {
  ainewAiSettinginfo({}).then((res) => {
    if (res.code == 200) {
      AiSettinginfo.value = res.data;
    }
  });
}

function fetchStorageInfo() {
  if (!localStorage.getItem("userId") || isSubAccount.value) {
    storageInfo.value = {};
    return;
  }
  teamMyStorage()
    .then((res) => {
      if (res.code === 200) {
        const list = Array.isArray(res.data) ? res.data : [];
        storageInfo.value = list[0] || {};
      } else {
        storageInfo.value = {};
      }
    })
    .catch(() => {
      storageInfo.value = {};
    });
}

function applyUserInfo(data) {
  if (!data) return;
  userInfoData.value = data;
  localStorage.setItem("userInfo", JSON.stringify(data));
  fetchStorageInfo();
}

function getuserInfo() {
  if (!localStorage.getItem("userId")) return;
  userInfo({
    userId: localStorage.getItem("userId"),
  }).then((res) => {
    if (res.code == 200) {
      applyUserInfo(res.data);
    }
  });
}

function handleRefreshUserInfo(payload) {
  if (payload && typeof payload === "object") {
    applyUserInfo(payload);
    return;
  }
  getuserInfo();
}

function checkLoginStatus() {
  islogin.value = !!localStorage.getItem("userId");
}

function handleToggle() {
  emit("toggle");
}

function handleLogin() {
  if (islogin.value) {
    localStorage.removeItem("userId");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    islogin.value = false;
    storageInfo.value = {};
  }
  emit("login");
}

function handleCreateProject() {
  if (!localStorage.getItem("userId")) return emit("login");
  EventBus.$emit(EVENTS.SHOW_CREATE_PROJECT);
}

function handleProjectsClick() {
  if (!localStorage.getItem("userId")) {
    emit("login");
    return;
  }
  if (route.path !== "/projects") {
    router.push("/projects");
  }
}

function handleCreditsClick() {
  if (!localStorage.getItem("userId")) return emit("login");
  if (route.path !== "/credits") {
    router.push("/credits");
  }
}

function handleMessageClick() {
  if (!localStorage.getItem("userId")) return emit("login");
  EventBus.$emit(EVENTS.SHOW_MESSAGE_CENTER);
}

function handleTutorialClick() {
  const url = AiSettinginfo.value.tutorial;
  if (!url) return ElMessage.warning("未配置教程地址");
  window.open(url, "_blank");
}

function handleCommunityClick() {
  EventBus.$emit(EVENTS.SHOW_COMMUNITY_DIALOG);
}

function handleInvitationClick() {
  if (!localStorage.getItem("userId")) return emit("login");
  router.push("/invitation");
}

function handleProfileClick() {
  if (!localStorage.getItem("userId")) return emit("login");
  router.push("/profile");
}

getainewAiSettinginfo();
checkLoginStatus();
getuserInfo();

onMounted(() => {
  checkLoginStatus();
  EventBus.$on(EVENTS.REFRESH_USER_INFO, handleRefreshUserInfo);
});

onActivated(() => {
  checkLoginStatus();
  getuserInfo();
});

onBeforeUnmount(() => {
  EventBus.$off(EVENTS.REFRESH_USER_INFO, handleRefreshUserInfo);
});
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.logo-container {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid #2d2d2d;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #2d2d2d;
  }

  .logo-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .logo-text {
    margin-left: 12px;
    font-size: 18px;
    font-weight: 600;
    color: #8bff8b;
    white-space: nowrap;
    flex: 1;
  }

  .collapse-icon {
    color: #888;
    font-size: 14px;
    transition: transform 0.3s ease;
  }
}

.sidebar-menu {
  border-right: none !important;

  :deep(.el-menu-item) {
    height: 48px;
    line-height: 48px;
    font-size: 14px;

    &:hover {
      background-color: #2d2d2d !important;
    }

    &.is-active {
      background-color: #2d2d2d !important;
      color: #8bff8b !important;

      .el-icon {
        color: #8bff8b !important;
      }
    }

    .el-icon {
      font-size: 18px;
      margin-right: 10px;
      color: #b3b3b3;
    }
  }
}

.menu-item-wrapper {
  cursor: pointer;

  :deep(.el-menu-item) {
    cursor: pointer;

    &.is-active {
      background-color: transparent !important;
      color: #b3b3b3 !important;

      .el-icon {
        color: #b3b3b3 !important;
      }
    }
  }

  &:hover {
    :deep(.el-menu-item) {
      background-color: #2d2d2d !important;
    }
  }

  &.is-route-active :deep(.el-menu-item) {
    background-color: #2d2d2d !important;
    color: #8bff8b !important;

    .el-icon {
      color: #8bff8b !important;
    }
  }
}

.bottom-menu {
  margin-top: auto;
  border-top: 1px solid #2d2d2d;
  padding-top: 8px;
}

.power-tag {
  margin-left: 8px;
  background-color: #8bff8b !important;
  border-color: #8bff8b !important;
  color: #1a1a1a !important;
}

.storage-section {
  padding: 14px 20px 16px;
  // border-top: 1px solid #2d2d2d;
}

.storage-title {
  color: #b3b3b3;
  font-size: 13px;
  line-height: 1;
  margin-bottom: 12px;
}

.storage-progress {
  height: 8px;
  border-radius: 999px;
  background-color: #3a3a3a;
  overflow: hidden;
}

.storage-progress-inner {
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s ease, background-color 0.3s ease;

  &.is-safe {
    background-color: #8bff8b;
  }

  &.is-danger {
    background-color: #ff3e3e;
  }
}

.storage-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 10px;
}

.storage-used {
  color: #b3b3b3;
  font-size: 12px;
  line-height: 1;
}

.storage-status {
  color: #b3b3b3;
  font-size: 12px;
  line-height: 1;

  &.is-inactive {
    color: #ff6c6c;
  }
}

.login-btn {
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 20px;
  color: #8bff8b;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  border-top: 1px solid #2d2d2d;

  .el-icon {
    font-size: 18px;
    margin-right: 10px;
  }

  &.is-collapse {
    justify-content: center;
    padding: 0;

    .el-icon {
      margin-right: 0;
    }
  }

  &:hover {
    background-color: #2d2d2d;
  }
}
</style>
